<script>
	import { onMount, getContext } from 'svelte'
	import { fade } from 'svelte/transition'
	import { styles } from '../scripts/styles.js'

	let visible = false
	const globals = getContext('globals')
	export let bg = globals.bgShader
	export let showLogo = 'none'
	export let opacity = '1'
	export let marginTop = 0

	onMount(() => {
		visible = true
	})
</script>

{#if visible}
	<div out:fade={{ duration: 1000 }} class="shader" use:styles={{ bg, opacity, marginTop }}>
		{#if showLogo === 'show'}
			<div class="logo" />
		{/if}
		<slot name="content" />
	</div>
{/if}

<style>
	.shader {
		position: fixed;
		top: var(--marginTop);
		left: 0px;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
		width: 100vw;
		background-color: var(--bg);
		z-index: 1000;
		opacity: var(--opacity);
	}

	.logo {
		position: fixed;
		top: 20px;
		width: 15%;
		height: 10%;
		background-image: url('../images/logo.svg');
		background-size: contain;
		background-repeat: no-repeat;
	}
</style>
